window.addEventListener('DOMContentLoaded', (event) => {
    $(document).ready(function () {
           $(document).on('click','#continue_shopping_btn', function(e){
            e.preventDefault();
            const url = sessionStorage.getItem('prevPath');
            location.href = url;
          })


        $(document).on('change', '#setLimit', function () {
            let ids = $(this).val();
            $('#setLimit').val(ids)
            setTimeout(() => {
                $('#setLimit').val(ids)
            }, 500)
            setTimeout(() => {
                $('#setLimit').val(ids)
            }, 1000)
            setTimeout(() => {
                $('#setLimit').val(ids)
            }, 2000)
        })

        $('.click_img').on('click', function () {
            let id = $(this).attr('attr');
            if ($(this).hasClass('hide_png')) {
                $(this).removeClass('active')
                $("img.view_png[attr='" + id + "']").addClass('active')
                $('#' + id).attr("type", "text");
            } else {
                $(this).removeClass('active')
                $("img.hide_png[attr='" + id + "']").addClass('active')
                $('#' + id).attr("type", "password");
            }
        })

        $(document).on('click', '.facetsItem', function () {
            let iId = $(this).attr('order');
            var attr = $('.facetsItem_main_div_' + iId).attr('open');
            if (typeof attr !== 'undefined' && attr !== false) {
                $('.facetsItem_main_div_' + iId).removeAttr('open');
            } else {
                $('.facetsItem_main_div_' + iId).attr('open', 'open');
            }
        })
$(document).on('click','#verified_signin',function(){
 $('#confirm_bid_modal').css('visibility','hidden')   
})

        $(document).on('click', '.btn-au', function () {
            $(this).toggleClass('active');
            const parent = $(this).closest('.auction_wrapper');
            const content = parent.find('.au_bottom_content');
            content.toggleClass('active');
        })

        if ($(window).width() < 768) {
           
            let sliderno = 1;
            if (window.location.href.indexOf("account") > -1) {
                sliderno = 2;
            } else if (window.location.href.indexOf("my-auctions") > -1) {
                sliderno = 3;
            } else if (window.location.href.indexOf("my-wantlist") > -1) {
                sliderno = 4;
            } else if (window.location.href.indexOf("swym-wishlist") > -1) {
                sliderno = 5;
            } else if (window.location.href.indexOf("order-history") > -1) {
                sliderno = 6;
            }
            $(".navigation-dashboard-ul").css('width', $(window).width())
            $(".navigation-dashboard-ul").slick({
                slidesToShow: 3,
                slidesToScroll: 1,
                adaptiveHeight: true,
                dots: false,
                arrows: false,
            });
            $('.navigation-dashboard-ul').slick('slickGoTo', parseInt(sliderno - 1));
      
        }

        $('.slick-list-common').each(function () {
            let item = $(this).attr('attr')
            $("." + item).slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: true,
                infinite: true,
                autoplay: false,
                dots: true,
                dotsClass: 'custom_paging',
                customPaging: function (slider, i) {

                    let totapage = slider.slideCount;
                    if (totapage < 10) {
                        totapage = '0' + totapage;
                    }
                    let shownNumber = (i + 1);
                    if (shownNumber < 10) {
                        shownNumber = '0' + shownNumber;
                    }

                    return shownNumber + '/ <span class="total_number_of_slider">' + totapage + '</span>';
                }
            });
            $(".prev-btn").click(function () {
                $("." + item).slick("slickPrev");
            });

            $(".next-btn").click(function () {
                $("." + item).slick("slickNext");
            });
            $(".prev-btn").addClass("slick-disabled");
            $("." + item).on("afterChange", function () {
                if ($(".slick-prev").hasClass("slick-disabled")) {
                    $(".prev-btn").addClass("slick-disabled");
                } else {
                    $(".prev-btn").removeClass("slick-disabled");
                }
                if ($(".slick-next").hasClass("slick-disabled")) {
                    $(".next-btn").addClass("slick-disabled");
                } else {
                    $(".next-btn").removeClass("slick-disabled");
                }
            });
        });
    })

    if ($('.articles_slider').length > 0) {
        $('.articles_slider').slick({
            slidesToShow: 2,
            slidesToScroll: 1,
            adaptiveHeight: true,
            infinite: false,
            arrows: false,
            dots: false,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        infinite: true,
                        dots: true
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
                // You can unslick at a given breakpoint now by adding:
                // settings: "unslick"
                // instead of a settings object
            ]
        })
    }
    var searchVal = ''

    $('.country_search').on("search", function (evt) {
        if ($(this).val().length > 0) { } else {
            $('.tag-filters__itemcountry_items').removeClass('hidden')
        }
    });

    $('.country_search').keyup(function (event) {
        if (event.originalEvent.keyCode > 64 && event.originalEvent.keyCode < 90 || event.originalEvent.keyCode == 8) {

            if (event.originalEvent.keyCode != 8) {
                searchVal += event.originalEvent.key;
            } else {
                searchVal = searchVal.slice(0, -1);
            }
            console.log('event', event.originalEvent.keyCode);
            $('.tag-filters__itemcountry_items').each(function () {
                let item = $(this).attr('value').toLowerCase();
                console.log(item)
                if (item.indexOf(searchVal) == -1) {
                    $(this).addClass('hidden')
                } else {
                    $(this).removeClass('hidden')
                }
            })
        }

    })
    $('.go_collection_page').on('click', function () {
        let collection_url = $(this).attr('attr');
        window.location.href = collection_url;

    })
    //$('.dropdown_carret').on('click',function(){
    $(document).on('click', '.dropdown_carret', function () {
        $(this).toggleClass('active')
        $('.facets-container-mobile').toggleClass('active')
    })
    $('.footer_img').on('click', function () {
        window.location.href = '/'
    })

    $('.faq-question').click(function () {
        $(this).siblings('.faq-answer').slideToggle();
        $(this).parent().toggleClass('open-state');
        if ($(this).find('.fa').hasClass('fa-plus')) {
            $(this).find('.fa').removeClass('fa-plus');
            $(this).find('.fa').addClass('fa-minus');
        } else if ($(this).find('.fa').hasClass('fa-minus')) {
            $(this).find('.fa').removeClass('fa-minus');
            $(this).find('.fa').addClass('fa-plus');
        }
    });
});


$('#remember-me-checkbox').on('change', function () {
    let isChecked = $('#remember-me-checkbox')[0].checked
    console.log(isChecked);
    if (isChecked) {
        $('input[name="customer[remember]"]').val(true);
    } else {
        $('input[name="customer[remember]"]').val(false);
    }
});
$('#remember-me-checkbox_signup').on('change', function () {
    let isChecked = $('#remember-me-checkbox_signup')[0].checked
    console.log(isChecked);
    if ($(this).is(':checked')) {
        $('input[name="customer[remember]"]').val(true);
    } else {
        $('input[name="customer[remember]"]').val(false);
    }
});
$('#signup-newsletter-checkbox').on('change', function () {
    let isChecked = $('#accepts_marketing')[0].checked
    console.log(isChecked);
    if ($(this).is(':checked')) {
        $('input[name="customer[accepts_marketing]"]').val(true);
    } else {
        $('input[name="customer[accepts_marketing]"]').val(false);
    }
});

$('#RegisterForm-password').on('keyup', function () {
    var password = $(this).val();
    var passwordRegex = /^(?=.*[a-z])(?=.*[A-Z]).{8,}$/;
    if (passwordRegex.test(password)) {
        $('.password_error').text('');
    } else {
        $('.password_error').text('Password must contain at least 8 characters, with at least one lowercase and one uppercase letter.');
    }
});

$('#confirm-password').on('keyup', function () {
    var password = $('#RegisterForm-password').val();
    var confirmPassword = $(this).val();
    if (password === confirmPassword) {
        $('.confirm_password_error').text('');
    } else {
        $('.confirm_password_error').text('Passwords do not match.');
    }
});



$('#eremember-me-checkbox').on('change', function () {
    let isChecked = $('#eremember-me-checkbox')[0].checked
    console.log(isChecked);
    if ($(this).is(':checked')) {
        $('input[name="customer[remember]"]').val(true);
    } else {
        $('input[name="customer[remember]"]').val(false);
    }
});
$('#eremember-me-checkbox_signup').on('change', function () {
    let isChecked = $('#eremember-me-checkbox_signup')[0].checked
    console.log(isChecked);
    if ($(this).is(':checked')) {
        $('input[name="customer[remember]"]').val(true);
    } else {
        $('input[name="customer[remember]"]').val(false);
    }
});
$('#esignup-newsletter-checkbox').on('change', function () {
    let isChecked = $('#eaccepts_marketing')[0].checked
    console.log(isChecked);
    if ($(this).is(':checked')) {
        $('input[name="customer[accepts_marketing]"]').val(true);
    } else {
        $('input[name="customer[accepts_marketing]"]').val(false);
    }
});

$('#eRegisterForm-password').on('keyup', function () {
    var password = $(this).val();
    var passwordRegex = /^(?=.*[a-z])(?=.*[A-Z]).{8,}$/;
    if (passwordRegex.test(password)) {
        $('.epassword_error').text('');
    } else {
        $('.epassword_error').text('Password must contain at least 8 characters, with at least one lowercase and one uppercase letter.');
    }
});

$('#econfirm-password').on('keyup', function () {
    var password = $('#eRegisterForm-password').val();
    var confirmPassword = $(this).val();
    if (password === confirmPassword) {
        $('.econfirm_password_error').text('');
    } else {
        $('.econfirm_password_error').text('Passwords do not match.');
    }
});



$(document).ready(function () {
    $('#registration-form').submit(function (e) {
        e.preventDefault();
        // grecaptcha.reset(document.getElementById('re-captcha'));
        var password = $('#RegisterForm-password').val();
        var confirmPassword = $('#confirm-password').val();
        var passwordRegex = /^(?=.*[a-z])(?=.*[A-Z]).{8,}$/;

        if (passwordRegex.test(password)) {
            $('.password_error').text('');
        } else {
            $('.password_error').text('Password must contain at least 8 characters, with at least one lowercase and one uppercase letter.');
            return;

        }
        if (password === confirmPassword) {
            $('.confirm_password_error').text('');
        } else {
            $('.confirm_password_error').text('Passwords do not match.');
            return;
        }
        if (!$('#signup-tc-checkbox').is(':checked')) {
            $('.tc_error').text('Please accept the terms and conditions');
            return;
        }

        if (grecaptcha.getResponse(signUpPopup) === '') {
            console.log('reCaptcha not verified');
        
            // Create the error message element
            const errorMessage = document.createElement('div');
            errorMessage.textContent = 'Please verify that you are not a robot.';
            errorMessage.style.color = 'red';
            errorMessage.id = 'recaptchaError';
        
            // Add the error message under the reCAPTCHA
            document.querySelector('#reg-re-captcha').after(errorMessage);
        
            // Remove the error message after 5 seconds
            setTimeout(function() {
                errorMessage.remove();
            }, 5000);
            return;
        }

        var formData = $(this).serialize();
        $('#loading_image_wrapper').show();
        $.ajax({
            url: '/account',
            type: 'POST',
            data: formData,
            success: function (response) {
                grecaptcha.reset(signUpPopup);
                const parser = new DOMParser();
                let AddressFirstNameNew = $("#RegisterForm-FirstName").val()
                let AddressLastNameNew = $("#RegisterForm-LastName").val()
                let AddressCompanyNew = $("#AddressCompanyNew").val()
                let AddressAddress1New = $("#AddressAddress1New").val()
                let AddressAddress2New = $("#AddressAddress2New").val()
                let AddressCityNew = $("#AddressCityNew").val()
                let AddressCountryNew = $("#AddressCountryNew").val()
                let AddressProvinceNew = $("#AddressProvinceNew").val()
                let AddressZipNew = $("#AddressZipNew").val()
                let AddressPhoneNew = $("#AddressPhoneNew").val()
                // let AddressZipNew = $("#AddressZipNew").val()
                let info = {
                    "AddressFirstNameNew": AddressFirstNameNew,
                    "AddressLastNameNew": AddressLastNameNew,
                    "AddressCompanyNew": AddressCompanyNew,
                    "AddressAddress1New": AddressAddress1New,
                    "AddressAddress2New": AddressAddress2New,
                    "AddressCountryNew": AddressCountryNew,
                    "AddressCityNew": AddressCityNew,
                    "AddressProvinceNew": AddressProvinceNew,
                    "AddressZipNew": AddressZipNew,
                    "AddressPhoneNew": AddressPhoneNew
                }
                localStorage.setItem('info', JSON.stringify(info));
                window.location.href = 'https://emedals.myshopify.com/pages/confirmation';



            },
            error: function (xhr, status, error) {
                alert('There was an error creating your account: ' + error);
            }
        });
    });
    $('#eregistration-form').submit(function (e) {
        e.preventDefault();
        var password = $('#eRegisterForm-password').val();
        var confirmPassword = $('#econfirm-password').val();
        var passwordRegex = /^(?=.*[a-z])(?=.*[A-Z]).{8,}$/;

        if (passwordRegex.test(password)) {
            $('.epassword_error').text('');
        } else {
            $('.epassword_error').text('Password must contain at least 8 characters, with at least one lowercase and one uppercase letter.');
            return;

        }
        if (password === confirmPassword) {
            $('.econfirm_password_error').text('');
        } else {
            $('.econfirm_password_error').text('Passwords do not match.');
            return;
        }
        if (!$('#esignup-tc-checkbox').is(':checked')) {
            $('.tc_error').text('Please accept the terms and conditions');
            return;
        }

        if (grecaptcha.getResponse(signUpPopupExit) === '') {
            console.log('reCaptcha not verified');
        
            // Create the error message element
            const errorMessage = document.createElement('div');
            errorMessage.textContent = 'Please verify that you are not a robot.';
            errorMessage.style.color = 'red';
            errorMessage.id = 'recaptchaError';
        
            // Add the error message under the reCAPTCHA
            document.querySelector('#reg2-re-captcha').after(errorMessage);
        
            // Remove the error message after 5 seconds
            setTimeout(function() {
                errorMessage.remove();
            }, 5000);
            return;
        }

        var formData = $(this).serialize();
        $('#loading_image_wrapper').show();
        $.ajax({
            url: '/account',
            type: 'POST',
            data: formData,
            success: function (response) {
                grecaptcha.reset(signUpPopupExit);
                const parser = new DOMParser();
                let AddressFirstNameNew = $("#eRegisterForm-FirstName").val()
                let AddressLastNameNew = $("#eRegisterForm-LastName").val()
                let AddressCompanyNew = $("#eAddressCompanyNew").val()
                let AddressAddress1New = $("#eAddressAddress1New").val()
                let AddressAddress2New = $("#eAddressAddress2New").val()
                let AddressCityNew = $("#eAddressCityNew").val()
                let AddressCountryNew = $("#eAddressCountryNew").val()
                let AddressProvinceNew = $("#eAddressProvinceNew").val()
                let AddressZipNew = $("#eAddressZipNew").val()
                let AddressPhoneNew = $("#eAddressPhoneNew").val()
                // let AddressZipNew = $("#AddressZipNew").val()
                let info = {
                    "AddressFirstNameNew": AddressFirstNameNew,
                    "AddressLastNameNew": AddressLastNameNew,
                    "AddressCompanyNew": AddressCompanyNew,
                    "AddressAddress1New": AddressAddress1New,
                    "AddressAddress2New": AddressAddress2New,
                    "AddressCountryNew": AddressCountryNew,
                    "AddressCityNew": AddressCityNew,
                    "AddressProvinceNew": AddressProvinceNew,
                    "AddressZipNew": AddressZipNew,
                    "AddressPhoneNew": AddressPhoneNew
                }
                localStorage.setItem('info', JSON.stringify(info));
                window.location.href = 'https://emedals.myshopify.com/pages/confirmation';



            },
            error: function (xhr, status, error) {
                alert('There was an error creating your account: ' + error);
            }
        });
    });


    //$('input[type="radio"]').change(function() {
    $(document).on('click', '.radiobtn', function () {


        //.prop('checked', false);

        let name = $(this).attr('name');
        var hasClassActive = $(this).hasClass('active');
        //let oldvalue = $('input[name="'+name+'"]:checked').val();
        console.log(hasClassActive);



        if (name == 'type' || name == 'country' || name == 'category' || name == 'price') {
            $('.' + name + '_radio .svg_href_wrap').removeClass('active_parent')

            if (hasClassActive) {
                $('input[name="' + name + '"]').removeClass('active')
                $('input[name="' + name + '"]').prop('checked', false);
            } else {
                $(this).addClass('active')
                $(this).parent().addClass('active_parent')
            }

            createaUrl()
        }



    })

});


function createaUrl() {
    var priceValue = $('input[name="price"]:checked').val();
    var typeValue = $('input[name="type"]:checked').val();
    var countryValue = $('input[name="country"]:checked').val();
    var categoryValue = $('input[name="category"]:checked').val();

    var currentURL = window.location.href;
    var domainName = window.location.hostname;
    var rUrl = "https://" + domainName + '/collections/';
    var mainUrl = currentURL.replace(rUrl, "");
    var cutUrl = mainUrl.split('/')[0];
    let oldurl = cutUrl;


    if (typeValue != undefined) {
        if (oldurl == cutUrl) {
            cutUrl += '/' + typeValue;
        } else {
            cutUrl += '+' + typeValue;
        }
    }

    if (countryValue) {
        if (oldurl == cutUrl) {
            cutUrl += '/' + countryValue;
        } else {
            cutUrl += '+' + countryValue;
        }
    }

    if (categoryValue) {
        if (oldurl == cutUrl) {
            cutUrl += '/' + categoryValue;
        } else {
            cutUrl += '+' + categoryValue;
        }
    }

    if (priceValue) {
        if (oldurl == cutUrl) {
            cutUrl += '/' + priceValue;
        } else {
            cutUrl += '+' + priceValue;
        }
    }

    let goToUrl = rUrl + cutUrl
    window.location.href = goToUrl;
}

// Hide all but the first step of the form
$('.form-step').not(':first').hide();

// When the user clicks the "next" button on a step, validate the input and show the next step
$('.form-next').click(function () {
    if ($(this).attr('attr') == 'step-1') {
        if ($('#RegisterForm-FirstName').val() == '') {
            $('.first_name_error').html('First name is required.');
            return;
        } else {
            $('.first_name_error').html('');
        }
        if ($('#RegisterForm-LastName').val() == '') {
            $('.last_name_error').html('Last name is required.');
            return;
        } else {
            $('.last_name_error').html('');
        }
        if ($('#RegisterForm-email').val() == '') {
            $('.email_error').html('Email is required.');
            return;
        } else {
            $('.email_error').html('');
        }

        var email = $('#RegisterForm-email').val();
        var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(email)) {
            $('.email_error').html('Please add a valid email address.');
            return;
        } else {
            $('.email_error').html('');
        }
        $('.step-1').addClass('checked')
        $('.step-2').addClass('active')
    }


    if ($(this).attr('attr') == 'step-2') {

        if ($("#AddressPhoneNew").val() == '') {
            $('.phone_error').html('Phone Number is required.');
            return;
        } else {
            $('.phone_error').html('');
        }
        var phone = $('#AddressPhoneNew').val();
        var phoneregex = /^(\+)?(\d{1,2})?[( .-]*(\d{3})[) .-]*(\d{3,4})[ .-]?(\d{4})$/;
        console.log(phoneregex.test(phone), '<!-- phoneregex.test(phone) -->')
        if (!phoneregex.test(phone)) {
            $('.phone_error').html('Please add a valid Phone number.');
            return;
        } else {
            $('.phone_error').html('');
        }


        if ($("#AddressAddress1New").val() == '') {
            $('.addresses_error').html('Address is required');
            return;
        } else {
            $('.addresses_error').html('');
        }


        if ($("#AddressCityNew").val() == '') {
            $('.city_error').html('City is required.');
            return;
        } else {
            $('.city_error').html('');
        }

        if ($("#AddressProvinceNew").val() == '') {
            $('.state_error').html('State/province is required.');
            return;
        } else {
            $('.state_error').html('');
        }

        if ($("#AddressCountryNew").val() == '') {
            $('.country_error').html('Country is required.');
            return;
        } else {
            $('.country_error').html('');
        }

        if ($("#AddressZipNew").val() == '') {
            $('.zip_error').html('Zip code is required.');
            return;
        } else {
            $('.zip_error').html('');
        }
        $('.step-2').removeClass('extra_step')
        $('.step-2').addClass('checked')
        $('.step-3').addClass('active')
    }
    var currentStep = $(this).parents('.form-step');
    var nextStep = currentStep.next('.form-step');
    currentStep.hide();
    nextStep.show();
});

// When the user clicks the "back" button on a step, go back to the previous step
$('.form-prev').click(function () {
    var currentStep = $(this).parents('.form-step');
    var prevStep = currentStep.prev('.form-step');
    if ($(this).attr('attr') == 'step-1') {
        $('.step-1').removeClass('extra_step')
        $('.step-1').removeClass('checked')
        $('.step-2').removeClass('active')

    }
    if ($(this).attr('attr') == 'step-2') {
        $('.step-2').addClass('extra_step')
        $('.step-2').removeClass('checked')
        $('.step-3').removeClass('active')
    }

    currentStep.hide();
    prevStep.show();
});


$('.eform-step').not(':first').hide();

// When the user clicks the "next" button on a step, validate the input and show the next step
$('.eform-next').click(function () {
    console.log($(this).attr('attr'),'ertert');
    if ($(this).attr('attr') == 'step-1') {
        if ($('#eRegisterForm-FirstName').val() == '') {
            $('.efirst_name_error').html('First name is required.');
            return;
        } else {
            $('.efirst_name_error').html('');
        }
        if ($('#eRegisterForm-LastName').val() == '') {
            $('.elast_name_error').html('Last name is required.');
            return;
        } else {
            $('.elast_name_error').html('');
        }
        if ($('#eRegisterForm-email').val() == '') {
            $('.eemail_error').html('Email is required.');
            return;
        } else {
            $('.email_error').html('');
        }

        var email = $('#eRegisterForm-email').val();
        var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(email)) {
            $('.eemail_error').html('Please add a valid email address.');
            return;
        } else {
            $('.eemail_error').html('');
        }
        $('.step-1').addClass('checked')
        $('.step-2').addClass('active')
    }


    if ($(this).attr('attr') == 'step-2') {

        if ($("#eAddressPhoneNew").val() == '') {
            $('.ephone_error').html('Phone Number is required.');
            return;
        } else {
            $('.ephone_error').html('');
        }
        var phone = $('#eAddressPhoneNew').val();
        var phoneregex = /^(\+)?(\d{1,2})?[( .-]*(\d{3})[) .-]*(\d{3,4})[ .-]?(\d{4})$/;
        console.log(phoneregex.test(phone), '<!-- phoneregex.test(phone) -->')
        if (!phoneregex.test(phone)) {
            $('.ephone_error').html('Please add a valid Phone number.');
            return;
        } else {
            $('.ephone_error').html('');
        }


        if ($("#eAddressAddress1New").val() == '') {
            $('.eaddresses_error').html('Address is required');
            return;
        } else {
            $('.eaddresses_error').html('');
        }


        if ($("#eAddressCityNew").val() == '') {
            $('.ecity_error').html('City is required.');
            return;
        } else {
            $('.ecity_error').html('');
        }

        if ($("#eAddressProvinceNew").val() == '') {
            $('.estate_error').html('State/province is required.');
            return;
        } else {
            $('.estate_error').html('');
        }

        if ($("#eAddressCountryNew").val() == '') {
            $('.ecountry_error').html('Country is required.');
            return;
        } else {
            $('.ecountry_error').html('');
        }

        if ($("#eAddressZipNew").val() == '') {
            $('.ezip_error').html('Zip code is required.');
            return;
        } else {
            $('.ezip_error').html('');
        }
        $('.step-2').removeClass('extra_step')
        $('.step-2').addClass('checked')
        $('.step-3').addClass('active')
    }
    var currentStep = $(this).parents('.eform-step');
    var nextStep = currentStep.next('.eform-step');
    currentStep.hide();
    nextStep.show();
});

// When the user clicks the "back" button on a step, go back to the previous step
$('.eform-prev').click(function () {
    var currentStep = $(this).parents('.eform-step');
    var prevStep = currentStep.prev('.eform-step');
    if ($(this).attr('attr') == 'step-1') {
        $('.step-1').removeClass('extra_step')
        $('.step-1').removeClass('checked')
        $('.step-2').removeClass('active')

    }
    if ($(this).attr('attr') == 'step-2') {
        $('.step-2').addClass('extra_step')
        $('.step-2').removeClass('checked')
        $('.step-3').removeClass('active')
    }

    currentStep.hide();
    prevStep.show();
});


$('.custom_product_slider-new').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: false,
    centerMode: false,
    infinite: false,
    dots: false,
    arrows: true,
    responsive: [
        {
            breakpoint: 768,
            settings: {
                dots: true,
                slidesToShow: 1.05,
                arrows: false
            }
        }
    ]
});
// var currentSlide = 0;
// jQuery('.custom_product_slider-new').on('afterChange', function(event, slick, currentSlide, nextSlide){
//     currentSlide = jQuery('.custom_product_slider-new .slick-active').attr('data-slick-index');
//     console.log(currentSlide);
//     console.log(jQuery('.custom_product_slider-new .slick-active').attr('id'));
// });
// $('.custom_product_thumbnail_slider').slick({
//     slidesToShow: 6,
//     slidesToScroll: 1,
//     // adaptiveHeight: true,
//     dots: false,
//     arrows: false,
//     asNavFor: '.custom_product_slider-new',
//     focusOnSelect: true
// });
$('.custom-thumbnails .thumbnail-list__item').click(function(e) {
    e.preventDefault();
    var slideno = $(this).data('slideId');
    // console.log('here', slideno);
    $('.custom_product_slider-new').slick('slickGoTo', slideno - 1);
  });

  
  // Fancybox Config
  Fancybox.bind("[data-fancybox='main-gallery']", {
    // Your custom options
    hash : true,
    groupAll: true,
    protected: true,
    Images: {
        Panzoom: {
          maxScale: 4,
        },
    },
    initialSize: "fit",
    Thumbs: {
        type: "classic",
    }, 
    on: {
        init: (fancybox) => {
            setTimeout(() => {
                const currentSlide = parseInt(jQuery('.custom_product_slider-new .slick-active').attr('data-slick-index'));
                console.log(currentSlide);
                fancybox.jumpTo(currentSlide);
            }, 50);
        },
      },
      Toolbar: {
        display: {
          right: [
            "zoomIn",
            "zoomOut",
            "slideshow", 
            "thumbs", 
            "close"
            ],
        },
      },
  });


//   back To Top button

var btn = $('#backToTop');

$(window).scroll(function() {
  if ($(window).scrollTop() > 300) {
    btn.addClass('show');
  } else {
    btn.removeClass('show');
  }
});

btn.on('click', function(e) {
  e.preventDefault();
  $('html, body').animate({scrollTop:0}, '300');
});